// @ts-ignore
import Alpine from 'alpinejs'
// @ts-ignore
import intersect from '@alpinejs/intersect'
// @ts-ignore
import persist from '@alpinejs/persist'
// @ts-ignore
import focus from '@alpinejs/focus'
// @ts-ignore
import helpers from './components/helpers'
// @ts-ignore
import productHeroCarousel from './components/product-hero-carousel'
// @ts-ignore
import productCarousel from './components/product-carousel'
// @ts-ignore
require('fslightbox')

// @ts-ignore
window.Alpine = Alpine

// @ts-ignore
window.mosesApp = {
  helpers,
  productHeroCarousel,
  productCarousel
}

Alpine.plugin(intersect)
Alpine.plugin(persist)
Alpine.plugin(focus)
Alpine.start()

export {
    Alpine
}
